import BASE_URL from "../config";

/**
 * Submit Product On Demand form with optional image attachment
 * @param {FormData} formData
 */
export const submitProductOnDemandForm = async (formData) => {
  try {
    const response = await fetch(`${BASE_URL}/product-on-demand`, {
      method: "POST",
      body: formData, // FormData automatically sets multipart/form-data boundary
    });

    const result = await response.json().catch(() => ({}));

    return { ok: response.ok, status: response.status, ...result };
  } catch (error) {
    console.error("submitProductOnDemandForm error:", error);
    return { ok: false, message: error.message || "Network error. Please try again." };
  }
};

/**
 * Get Product On Demand submissions (Admin Only)
 */
export const getProductOnDemandSubmissions = async ({
  token,
  page = 1,
  limit = 20,
  search = "",
  status = "",
}) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);
    if (search) params.append("search", search);
    if (status) params.append("status", status);

    const response = await fetch(`${BASE_URL}/product-on-demand?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = await response.json().catch(() => ({}));

    return { ok: response.ok, status: response.status, ...result };
  } catch (error) {
    console.error("getProductOnDemandSubmissions error:", error);
    return { ok: false, message: error.message || "Failed to fetch submissions" };
  }
};

/**
 * Update submission status (Admin Only)
 */
export const updateProductOnDemandStatus = async (id, status, token) => {
  try {
    const response = await fetch(`${BASE_URL}/product-on-demand/${id}/status`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ status }),
    });

    const result = await response.json().catch(() => ({}));

    return { ok: response.ok, status: response.status, ...result };
  } catch (error) {
    console.error("updateProductOnDemandStatus error:", error);
    return { ok: false, message: error.message || "Failed to update status" };
  }
};

/**
 * Delete submission (Admin Only)
 */
export const deleteProductOnDemandSubmission = async (id, token) => {
  try {
    const response = await fetch(`${BASE_URL}/product-on-demand/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = await response.json().catch(() => ({}));

    return { ok: response.ok, status: response.status, ...result };
  } catch (error) {
    console.error("deleteProductOnDemandSubmission error:", error);
    return { ok: false, message: error.message || "Failed to delete submission" };
  }
};
